<h4 mat-dialog-title transloco="label_confirmation"></h4>
<mat-dialog-content>
    <p transloco="sentence_are_you_sure_logout_message"></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" transloco="label_cancel" class="me-2"></button>
    <button mat-flat-button cdkFocusInitial (click)="onLogout()" transloco="label_log_out"></button>
</mat-dialog-actions>